import Box from '@mui/material/Box';
import { makeStyles } from '@mui/styles';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import authActions from 'modules/auth/actions/AuthActions';
import InfoView from './shared/components/InfoView';
import AppLayout from './shared/components/layout/AppLayout';
import ContentView from './shared/components/layout/ContentView';
import useStyles from './shared/jss/common/common.style';
import { CremaTheme } from './shared/models/AppContextPropsType';
import { AppState } from './shared/store';

const useStyle = makeStyles((theme: CremaTheme) => ({
  appAuth: {
    flex: 1,
    display: 'flex',
    position: 'relative',
    height: '100vh',
    backgroundColor: theme.palette.primary.main,
    background: `url(${process.env.PUBLIC_URL + '/auth-background.jpg'}) no-repeat center center`,
    backgroundSize: 'cover',

    '& .scrollbar-container': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    '& .main-content-view': {
      padding: 20,
    },
    '& .footer': {
      marginRight: 0,
      marginLeft: 0,
    },
  },
}));

interface CremaLayoutProps { }

const CremaLayout: React.FC<CremaLayoutProps> = () => {
  useStyles();
  const dispatch = useDispatch();

  const {user, rolesConfig} = useSelector<AppState, AppState['auth']>(({auth}) => auth);

  useEffect(() => {
    // Load roles config if not loaded yet
    if (!rolesConfig) {
      dispatch(authActions.loadRolesConfig());
    }
  }, [rolesConfig, dispatch])

  
  const classes = useStyle();
  return (
    <>
      {user ? (
        <AppLayout />
      ) : (
        <Box className={classes.appAuth}>
          <ContentView />
          <InfoView />
        </Box>
      )}
    </>
  );
};

export default React.memo(CremaLayout);
